export interface LayoutSettings {
  nodeRepulsion: number;
  idealEdgeLength: number;
  edgeElasticity: number;
  initialEnergyOnIncremental: number;
}

export const defaultLayoutSettings: LayoutSettings = {
  nodeRepulsion: 45000,
  idealEdgeLength: 50,
  edgeElasticity: 0.45,
  initialEnergyOnIncremental: 0.7
};

export type GraphLinkMode = 'parent-links' | 'explicit-links' | 'all-links';

export type NeighbourSettings = 'none' | 'all';